import React, { useCallback, memo } from 'react';
import { Icon, Typography, ButtonMenu } from '@ann/web-components';
import {
  ItemWrapper,
  ItemLeft,
  ItemIcon,
  ItemContent,
  ItemTitle,
  ItemMeta,
} from './ListItem.styled';

const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

const DriveListItem = ({ drive, onClick, onRemoveAccess }) => {
  const handleMenuChange = useCallback((value) => {
    if (value === 'remove-access') {
      onRemoveAccess?.(drive);
    } else if (value === 'view-details') {
      onClick?.(drive);
    }
  }, [drive, onClick, onRemoveAccess]);

  const handleItemClick = useCallback(() => {
    onClick?.(drive);
  }, [drive, onClick]);

  // Handler para detener propagación del click en el menu
  const handleMenuClick = useCallback((e) => {
    e.stopPropagation();
  }, []);

  return (
    <ItemWrapper onClick={handleItemClick}>
      <ItemLeft>
        <ItemIcon>
          <Icon name="folder" size="medium" />
        </ItemIcon>
        <ItemContent>
          <ItemTitle>
            <Typography category="subtitle" size="medium" weight="bold" color="title">
              {drive.name || 'Unnamed Drive'}
            </Typography>
          </ItemTitle>
          {drive.description && (
            <Typography category="body" size="small" color="body">
              {drive.description}
            </Typography>
          )}
          <ItemMeta>
            <Typography category="body" size="small" color="subtitle">
              {drive.owner || drive.createdBy || 'Unknown'} • {drive.documentCount || drive.files_count || 0} files • {formatDate(drive.created_at || drive.createdAt)}
            </Typography>
          </ItemMeta>
        </ItemContent>
      </ItemLeft>
      <div onClick={handleMenuClick}>
        <ButtonMenu
          customIcon="dotsMenu"
          disableEffects
          iconPosition="right"
          label=""
          menuPosition="bottom"
          onChange={handleMenuChange}
          size="medium"
          type="tertiary"
          width="260px"
        >
          <ButtonMenu.Menu>
            <ButtonMenu.Item label="Remove access" value="remove-access" />
            <ButtonMenu.Item label="View details" value="view-details" />
          </ButtonMenu.Menu>
        </ButtonMenu>
      </div>
    </ItemWrapper>
  );
};

DriveListItem.displayName = 'DriveListItem';

export default memo(DriveListItem);

